import React, { memo, useEffect, useState } from "react";
import SlideOutSidebar from "../../../../ui-components/slide-out-sidebar/slideOutSidebar";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "./operationsReviewItemDetails.scss";
import { ShipmentWorkItemAccessorialsState } from "../../../../slices/shipment-reconciliation/ShipmentReconciliationState";
import { getShipmentWorkItemAccessorials, shipmentWorkItemAccessorialsSelector } from "../../../../slices/shipment-reconciliation/shipmentWorkItemAccessorialsSlice";
import { ReactComponent as PickupCancel } from "../../../../images/file_blue.svg";
import Table from "../../../../ui-components/table/table";
import { getOperationsReviewAccessorialsColumns } from "./operationsReviewAccessorialsColumns";
import { AccessorialApprovalStatus, ShipmentWorkItemAccessorial } from "../../../../app/data/shipment-reconciliation/models";
import OperationAccessorialApproval from "../accessorial-approval/operationAccessorialApproval";

interface OperationsReviewItemDetailsProps {
  shipmentWorkItemId: number,
  probillNumber: number,
  onClose: any
}

const OperationsReviewItemDetails: React.FC<OperationsReviewItemDetailsProps> = memo((props) => {
  const dispatch = useDispatch();
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState<AccessorialApprovalStatus | null>(null);
  const [selectedAccessorial, setSelectedAccessorial] = useState<ShipmentWorkItemAccessorial | null>(null);

  const shipmentWorkItemAccessorials: ShipmentWorkItemAccessorialsState = useSelector(
    shipmentWorkItemAccessorialsSelector
  );

  useEffect(() => {
    dispatch(getShipmentWorkItemAccessorials(
      props.shipmentWorkItemId,
      {isOperationsReviewRequired: true},
      (error) => { toast.error(error) }
    ));
  }, [dispatch, props.shipmentWorkItemId]);


  const onAccessorialApproval = (approvalStatus: AccessorialApprovalStatus, accessorial: ShipmentWorkItemAccessorial) =>{
    setSelectedApprovalStatus(approvalStatus);
    setSelectedAccessorial(accessorial);
  }

  const resetApprovalSelection = () =>{
    setSelectedApprovalStatus(null);
    setSelectedAccessorial(null);
  }

  const onApprovalSucccess = () => {
    dispatch(getShipmentWorkItemAccessorials(
      props.shipmentWorkItemId,
      {isOperationsReviewRequired: true},
      (error) => { toast.error(error) }
    ));
  }

  return (
    <SlideOutSidebar
      header={`Details for Probill # ${props.probillNumber}`}
      onClose={props.onClose}
      size="medium"
      show={!!props.shipmentWorkItemId}
    ><div className="xgs-operations-review-item-details">
        <div className="content-box">
          <div className="header">
            <div className="icon-container"><PickupCancel /></div>
            <div className="title">Accessorials</div>
          </div>
          <div className="content">
            <div className="content__table-wrapper">
              <Table
                isLoading={shipmentWorkItemAccessorials.loading}
                columns={getOperationsReviewAccessorialsColumns(onAccessorialApproval)}
                data={shipmentWorkItemAccessorials.accessorials}
                cursorPointer={true}
                // rowHeight={100}
                noResultsText="No Accessorials available"
                onSelectedRowsChange={null}
                responsive={true}
              />
            </div>
          </div>
        </div>
      </div>
      { !!(selectedAccessorial && selectedAccessorial.id && selectedApprovalStatus) && <OperationAccessorialApproval 
            shipmentWorkItemId = {selectedAccessorial.shipmentWorkItemId}
            accessorialId={selectedAccessorial.id}
            accessorialName={selectedAccessorial.accessorialDefinition.name}
            accessorialRate={selectedAccessorial.accessorialDefinition.rate}
            approvalStatus={selectedApprovalStatus}
            onClose={resetApprovalSelection}
            onSuccess={onApprovalSucccess}
        /> 
      }
    </SlideOutSidebar>
  );
});

export default OperationsReviewItemDetails;
